module.exports = __webpack_public_path__ + "img/story050.e323ca46.webp";